// Server-Aufrufe des Spielmodus: Zug von Stockfish holen, fertige Partie in der Bibliothek speichern.
import type { Move } from 'chessops/types';
import { parseUci } from 'chessops/util';
import type { Key } from '@lichess-org/chessground/types';
import { api } from './api';
import { t } from './i18n';
import type { PlayCtrl } from './playctrl';
import { botName, botRequest, type BotChoice } from './playbots';
import { gamePgn } from './playpgn';

/** Zug des Gegners; mindestens 350 ms, damit er nicht im selben Moment wie der eigene kommt */
export async function engineReply(fen: string, bot: BotChoice): Promise<{ move: Move; last: [Key, Key] }> {
  const started = performance.now();
  const r = await api.playMove(fen, botRequest(bot));
  const wait = 350 - (performance.now() - started);
  if (wait > 0) await new Promise(res => setTimeout(res, wait));
  const move = r.bestmove ? parseUci(r.bestmove) : undefined;
  if (!move || !('from' in move)) throw new Error(t('Der Gegner hat keinen Zug geliefert.'));
  return { move, last: [r.bestmove!.slice(0, 2) as Key, r.bestmove!.slice(2, 4) as Key] };
}

export async function saveGame(c: PlayCtrl) {
  const engine = botName(c.bot);
  const you = t('Spieler');
  const pgn = gamePgn({
    sans: c.moves.map(m => m.san),
    white: c.me === 'white' ? you : engine,
    black: c.me === 'black' ? you : engine,
    result: c.outcome ?? '*',
    event: t('Partie gegen {n}', { n: botName(c.bot) }),
    date: new Date(),
    fen: c.board.start,
  });
  try {
    await api.importText(pgn);
    c.saved = true;
  } catch (e) {
    c.error = (e as Error).message;
  }
  c.redraw();
}
